import { userService } from '../services';

const initialState = { all: {} };

const getters = {
  getLoggState: state => ({
    is: state.is,
  }),
};

const actions = {
  getUser({ dispatch, commit }, { key }) {

    userService.getUserByKey(key)
        .then(
            users => commit('getAllSuccess', users),
            error => { commit('getAllFailure', error), dispatch('alert/error', error, { root: true }); }
        );
  },
};

const mutations = {
  getAllRequest(state) {
      state.all = { loading: true };
  },
  getAllSuccess(state, users) {
      state.all = { items: users };
  },
  getAllFailure(state, error) {
      state.all = { error };
  }
};

export const users = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};